var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortugalFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.827 2.291 C 12.921 8.231 0 25.101 0 45 c 0 19.899 12.921 36.769 30.827 42.709 V 2.291 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,102,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 0 c -4.954 0 -9.715 0.812 -14.173 2.291 V 45 v 42.709 C 35.285 89.188 40.046 90 45 90 c 24.853 0 45 -20.147 45 -45 C 90 20.147 69.853 0 45 0 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.259 44.98 L 48.259 44.98 l 0 -0.028 c -0.067 -0.078 -0.15 -0.156 -0.239 -0.233 c -0.136 -2.274 -0.723 -4.432 -1.672 -6.385 c 0.128 -0.06 0.204 -0.107 0.225 -0.139 c 0.002 0.001 0.004 0.002 0.006 0.004 l -0.277 -0.489 c -0.049 -0.054 -0.14 -0.115 -0.264 -0.18 l -0.325 -0.562 c 0.065 -0.036 0.116 -0.07 0.154 -0.1 l 0 0 v 0 l -0.021 -0.035 c 0.01 0.011 0.022 0.021 0.032 0.032 l -0.404 -0.643 c -0.146 -0.109 -0.342 -0.221 -0.576 -0.334 c -2.959 -4.166 -7.73 -6.976 -13.133 -7.282 l 0 -0.354 h -0.375 l 0 0.197 h -1.086 v -0.197 h -0.378 V 28.6 c -5.42 0.268 -10.194 3.058 -13.162 7.214 c -0.226 0.009 -0.402 0.055 -0.52 0.144 l -0.017 0.03 h -0.003 l -0.204 0.357 l -0.028 0.056 v 0 c -0.041 0.111 -0.026 0.245 0.04 0.4 l -0.861 1.597 c -0.077 0.012 -0.142 0.033 -0.192 0.062 l -0.013 -0.004 l -0.2 0.354 c -0.088 0.14 -0.067 0.328 0.049 0.558 c -0.666 1.651 -1.081 3.427 -1.199 5.282 c -0.112 0.102 -0.187 0.198 -0.218 0.288 v 0.468 c 0 -0.001 0.001 -0.002 0.002 -0.003 l 0 0.014 c 0.038 0.022 0.087 0.049 0.146 0.078 v 0.697 c -0.074 0.078 -0.125 0.153 -0.149 0.224 v 0.468 c 0 -0.001 0.001 -0.002 0.002 -0.003 l 0 0.014 c 0.054 0.032 0.132 0.072 0.229 0.118 c 0.171 2.324 0.81 4.522 1.822 6.501 c -0.067 0.081 -0.108 0.16 -0.114 0.235 l 0.203 0.359 c 0 -0.001 0.001 -0.002 0.001 -0.003 l 0.002 0.004 c 0.055 0.017 0.121 0.038 0.192 0.059 l 0.443 0.722 c -0.048 0.061 -0.078 0.116 -0.086 0.164 l 0.002 0.004 l 0 0 l 0.205 0.352 c 0.125 0.054 0.259 0.109 0.398 0.164 c 2.962 4.211 7.769 7.045 13.232 7.315 v 0.365 h 0.379 v -0.201 h 1.088 l 0 0.201 h 0.376 l 0 -0.372 c 4.903 -0.278 9.285 -2.619 12.265 -6.164 c 0.278 0.029 0.435 0.02 0.525 -0.11 l 0.012 -0.009 l 0.214 -0.336 c 0.052 -0.077 0.053 -0.18 0.01 -0.308 l 1.007 -1.561 c 0.134 0.012 0.226 0.001 0.271 -0.036 c 0.008 -0.015 0.031 -0.054 0.058 -0.101 l 0.21 -0.32 v 0 l 0 0 c 0.074 -0.147 0.043 -0.348 -0.082 -0.597 c 0.959 -1.915 1.569 -4.03 1.743 -6.264 c 0.114 -0.069 0.2 -0.136 0.254 -0.198 c 0.001 0.001 0.002 0.002 0.002 0.003 l 0 -0.005 c 0 0 0.001 -0.001 0.001 -0.001 v -0.415 l 0 0 l 0 -0.028 c -0.056 -0.065 -0.122 -0.13 -0.194 -0.195 l -0.003 -0.061 V 45.56 c 0.085 -0.056 0.151 -0.11 0.195 -0.161 c 0.001 0.001 0.002 0.002 0.002 0.003 l 0 -0.005 c 0 0 0.001 -0.001 0.001 -0.001 V 44.98 z M 15 38.76 c 0.013 -0.002 0.027 -0.005 0.041 -0.007 l -0.03 0.05 C 15.007 38.789 15.004 38.774 15 38.76 z M 16.266 36.226 c 0.03 -0.01 0.061 -0.018 0.092 -0.025 l -0.005 0.003 l -0.063 0.118 C 16.281 36.291 16.273 36.26 16.266 36.226 z M 46.076 53.963 l 0.012 -0.069 c 0.013 0.052 0.02 0.102 0.021 0.149 c -0.029 0.007 -0.06 0.012 -0.094 0.015 L 46.076 53.963 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.39,28.25 31.39,28.25 31.39,28.25 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.515 47.638 c 0 2.83 1.159 5.389 3.036 7.259 c 1.881 1.874 4.437 3.057 7.271 3.057 c 2.849 0 5.434 -1.157 7.307 -3.024 c 1.873 -1.867 3.034 -4.444 3.034 -7.283 h 0 V 33.875 l -20.65 -0.024 L 20.515 47.638 L 20.515 47.638 L 20.515 47.638 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.901 47.657 v 0.008 c 0 2.706 1.12 5.169 2.917 6.958 c 1.801 1.792 4.281 2.906 6.994 2.906 c 2.727 0 5.202 -1.106 6.995 -2.891 c 1.793 -1.785 2.904 -4.249 2.904 -6.964 h 0 V 34.313 l -19.798 -0.003 L 20.901 47.657 M 36.73 38.309 l 0.001 8.503 l -0.007 0.9 c 0 0.237 -0.014 0.506 -0.042 0.736 c -0.161 1.344 -0.779 2.516 -1.695 3.427 c -1.072 1.067 -2.551 1.729 -4.182 1.729 c -1.622 0 -3.067 -0.685 -4.144 -1.757 c -1.104 -1.099 -1.744 -2.606 -1.744 -4.165 l -0.002 -9.395 L 36.73 38.309 L 36.73 38.309 L 36.73 38.309 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.428 38.026 h 2.947 c 0.074 0 0.133 -0.07 0.133 -0.156 c 0 -0.086 -0.06 -0.157 -0.133 -0.157 h -0.019 l -0.121 -1.034 h 0.017 c 0.068 0 0.124 -0.064 0.124 -0.143 c 0 -0.044 -0.018 -0.081 -0.045 -0.107 c 0.063 -0.009 0.113 -0.067 0.113 -0.139 c 0 -0.079 -0.058 -0.143 -0.129 -0.143 l -0.115 0 l -0.021 -0.567 h 0.02 c 0.065 0 0.114 -0.048 0.114 -0.111 l 0 -0.37 l -0.255 0 v 0.155 h -0.112 v -0.155 l -0.255 -0.001 v 0.155 H 23.58 v -0.152 l -0.249 -0.001 l 0 0.367 c 0 0.061 0.054 0.112 0.117 0.112 h 0.014 l -0.019 0.567 l -0.156 0 l -0.042 -1.106 l 0 -0.01 h 0.042 c 0.066 0 0.116 -0.048 0.116 -0.111 l 0 -0.37 h -0.26 v 0.155 H 23.03 v -0.154 l -0.259 -0.001 v 0.155 h -0.115 v -0.151 l -0.23 0 l -0.024 -0.008 l 0.001 0.374 c 0 0.061 0.055 0.112 0.12 0.112 h 0.028 l -0.038 1.117 l -0.156 0 l -0.021 -0.567 h 0.02 c 0.065 0 0.114 -0.048 0.114 -0.111 l 0.001 -0.37 l -0.255 0 v 0.155 h -0.112 v -0.155 l -0.255 -0.001 v 0.155 h -0.112 v -0.152 l -0.249 -0.001 l 0 0.367 c 0 0.061 0.054 0.112 0.117 0.112 h 0.014 l -0.019 0.567 l -0.108 0 c -0.071 0 -0.129 0.064 -0.129 0.143 c 0 0.071 0.048 0.128 0.11 0.139 c -0.027 0.026 -0.046 0.064 -0.046 0.108 c 0 0.079 0.056 0.143 0.124 0.143 h 0.019 l -0.111 1.034 h -0.03 c -0.074 0 -0.133 0.07 -0.133 0.157 C 21.294 37.956 21.354 38.026 21.428 38.026 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.508 45.925 c 0 -0.086 -0.06 -0.157 -0.133 -0.157 h -0.019 l -0.121 -1.034 h 0.017 c 0.068 0 0.124 -0.064 0.124 -0.143 c 0 -0.044 -0.018 -0.081 -0.045 -0.107 c 0.063 -0.009 0.113 -0.067 0.113 -0.139 c 0 -0.079 -0.058 -0.143 -0.129 -0.143 l -0.115 0 l -0.021 -0.567 h 0.02 c 0.065 0 0.114 -0.047 0.114 -0.11 l 0 -0.37 l -0.255 0 v 0.155 h -0.112 v -0.155 l -0.255 -0.001 v 0.155 H 23.58 v -0.152 l -0.249 -0.001 l 0 0.367 c 0 0.061 0.054 0.112 0.117 0.112 h 0.014 l -0.019 0.567 l -0.15 0 l -0.048 -1.107 l 0 -0.009 h 0.043 c 0.066 0 0.116 -0.048 0.116 -0.111 l 0 -0.37 h -0.26 v 0.155 H 23.03 v -0.154 l -0.259 -0.001 v 0.155 h -0.115 v -0.151 l -0.23 0 l -0.024 -0.008 l 0.001 0.374 c 0 0.061 0.055 0.112 0.12 0.112 h 0.033 l -0.049 1.117 l -0.151 0 l -0.021 -0.567 h 0.02 c 0.065 0 0.114 -0.047 0.114 -0.11 l 0.001 -0.37 l -0.255 0 v 0.155 h -0.112 v -0.155 l -0.255 -0.001 v 0.155 h -0.112 v -0.152 l -0.249 -0.001 l 0 0.367 c 0 0.061 0.054 0.112 0.117 0.112 h 0.014 l -0.019 0.567 l -0.108 0 c -0.071 0 -0.129 0.064 -0.129 0.143 c 0 0.071 0.048 0.128 0.11 0.139 c -0.027 0.026 -0.046 0.064 -0.046 0.108 c 0 0.079 0.056 0.143 0.124 0.143 h 0.019 l -0.111 1.034 h -0.03 c -0.074 0 -0.133 0.07 -0.133 0.157 c 0 0.086 0.06 0.156 0.133 0.156 h 2.947 C 24.448 46.081 24.508 46.011 24.508 45.925 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.808 52.623 l -0.013 0.013 l -0.819 -0.643 l 0.012 -0.012 c 0.048 -0.048 0.042 -0.133 -0.014 -0.189 c -0.029 -0.029 -0.068 -0.046 -0.106 -0.046 c 0 0 0 0 0 0 c 0.037 -0.051 0.031 -0.126 -0.02 -0.177 c -0.056 -0.056 -0.142 -0.06 -0.192 -0.009 l -0.081 0.082 l -0.417 -0.384 l 0.014 -0.014 c 0.022 -0.022 0.035 -0.052 0.035 -0.082 c 0 -0.029 -0.012 -0.056 -0.033 -0.077 l -0.262 -0.261 l -0.18 0.181 l 0.11 0.11 l -0.079 0.08 l -0.11 -0.109 l -0.18 0.18 l 0.11 0.11 l -0.079 0.079 l -0.108 -0.107 l -0.176 0.176 l 0.261 0.258 c 0.021 0.02 0.048 0.031 0.077 0.031 c 0.031 0 0.062 -0.012 0.085 -0.035 l 0.01 -0.01 l 0.389 0.413 l -0.105 0.106 l -0.819 -0.747 l -0.007 -0.006 l 0.03 -0.03 c 0.047 -0.047 0.048 -0.116 0.003 -0.16 l -0.262 -0.261 l -0.183 0.184 l 0.11 0.109 l -0.081 0.082 l -0.109 -0.109 l -0.184 0.183 l 0.11 0.109 l -0.081 0.082 l -0.107 -0.107 l -0.162 0.163 l -0.021 0.014 l 0.264 0.261 c 0.02 0.02 0.048 0.03 0.076 0.03 c 0.031 0 0.063 -0.012 0.087 -0.036 l 0.024 -0.024 l 0.758 0.822 l -0.106 0.107 l -0.417 -0.384 l 0.014 -0.014 c 0.021 -0.021 0.033 -0.049 0.034 -0.077 c 0.001 -0.03 -0.01 -0.059 -0.033 -0.081 l -0.262 -0.261 l -0.18 0.181 l 0.11 0.11 l -0.079 0.08 l -0.11 -0.109 l -0.18 0.18 l 0.11 0.11 l -0.079 0.079 l -0.108 -0.107 l -0.176 0.177 l 0.26 0.258 c 0.02 0.02 0.047 0.031 0.077 0.031 c 0 0 0 0 0 0 c 0.032 0 0.063 -0.013 0.085 -0.035 l 0.01 -0.01 l 0.389 0.413 l -0.076 0.077 c -0.022 0.022 -0.035 0.053 -0.035 0.087 c 0 0.039 0.017 0.077 0.045 0.105 c 0.03 0.029 0.068 0.045 0.105 0.045 c 0.025 0 0.048 -0.009 0.069 -0.023 c 0 0 0 0.001 0 0.001 c 0 0.039 0.017 0.077 0.046 0.107 c 0.056 0.055 0.141 0.061 0.189 0.013 l 0.013 -0.014 l 0.656 0.808 l -0.021 0.021 c -0.022 0.022 -0.034 0.053 -0.034 0.087 c 0 0.042 0.019 0.085 0.052 0.118 c 0.032 0.032 0.075 0.05 0.117 0.05 c 0 0 0 0 0 0 c 0.034 0 0.065 -0.013 0.088 -0.035 l 2.077 -2.091 c 0.052 -0.052 0.044 -0.144 -0.017 -0.205 C 26.952 52.578 26.86 52.571 26.808 52.623 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.325 37.713 h -0.019 l -0.121 -1.034 h 0.017 c 0.068 0 0.124 -0.064 0.124 -0.143 c 0 -0.044 -0.018 -0.081 -0.045 -0.107 c 0.063 -0.009 0.113 -0.067 0.113 -0.139 c 0 -0.079 -0.058 -0.143 -0.129 -0.143 l -0.115 0 l -0.021 -0.567 h 0.02 c 0.065 0 0.114 -0.048 0.114 -0.111 l 0 -0.37 l -0.255 0 v 0.155 h -0.112 v -0.155 l -0.255 -0.001 v 0.155 H 31.53 v -0.152 l -0.249 -0.001 l 0 0.367 c 0 0.061 0.054 0.112 0.117 0.112 h 0.014 l -0.019 0.567 l -0.156 0 l -0.042 -1.106 l 0 -0.01 h 0.042 c 0.066 0 0.116 -0.048 0.116 -0.111 l 0 -0.37 h -0.26 v 0.155 h -0.115 v -0.154 l -0.259 -0.001 v 0.155 h -0.115 v -0.151 l -0.23 0 l -0.024 -0.008 l 0.001 0.374 c 0 0.061 0.055 0.112 0.12 0.112 H 30.5 l -0.038 1.117 l -0.156 0 l -0.021 -0.567 h 0.02 c 0.065 0 0.114 -0.048 0.114 -0.111 l 0.001 -0.37 l -0.255 0 v 0.155 h -0.112 v -0.155 l -0.255 -0.001 v 0.155 h -0.112 v -0.152 l -0.249 -0.001 l 0 0.367 c 0 0.061 0.054 0.112 0.117 0.112 h 0.014 l -0.019 0.567 l -0.108 0 c -0.071 0 -0.129 0.064 -0.129 0.143 c 0 0.071 0.048 0.128 0.11 0.139 c -0.027 0.026 -0.046 0.064 -0.046 0.108 c 0 0.079 0.056 0.143 0.124 0.143 h 0.019 l -0.111 1.034 h -0.03 c -0.074 0 -0.133 0.07 -0.133 0.157 c 0 0.086 0.06 0.156 0.133 0.156 h 2.947 c 0.074 0 0.133 -0.07 0.133 -0.156 C 32.458 37.783 32.399 37.713 32.325 37.713 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.279 38.026 h 2.947 c 0.074 0 0.133 -0.07 0.133 -0.156 c 0 -0.086 -0.06 -0.157 -0.133 -0.157 h -0.03 l -0.111 -1.034 h 0.019 c 0.068 0 0.124 -0.064 0.124 -0.143 c 0 -0.044 -0.018 -0.082 -0.046 -0.108 c 0.062 -0.011 0.11 -0.067 0.11 -0.139 c 0 -0.079 -0.058 -0.143 -0.129 -0.143 l -0.108 0 l -0.019 -0.567 h 0.014 c 0.064 0 0.117 -0.051 0.117 -0.112 l 0.001 -0.367 l -0.249 0.001 v 0.152 h -0.112 v -0.155 l -0.255 0.001 v 0.155 H 39.44 v -0.155 l -0.255 0 l 0.001 0.37 c 0 0.063 0.049 0.111 0.114 0.111 h 0.02 l -0.021 0.567 l -0.156 0 l -0.038 -1.117 h 0.028 c 0.065 0 0.119 -0.051 0.119 -0.112 l 0.001 -0.346 l 0 -0.027 l -0.023 0.007 l -0.231 0 v 0.151 h -0.115 v -0.155 l -0.259 0.001 v 0.154 h -0.115 v -0.155 h -0.26 l 0 0.37 c 0 0.063 0.05 0.111 0.116 0.111 h 0.037 l -0.037 1.117 l -0.155 0 l -0.019 -0.567 h 0.014 c 0.064 0 0.117 -0.051 0.117 -0.112 l 0 -0.367 l -0.249 0.001 v 0.152 h -0.112 v -0.155 l -0.255 0.001 v 0.155 h -0.112 v -0.155 l -0.255 0 l 0 0.37 c 0 0.063 0.049 0.111 0.114 0.111 h 0.02 l -0.021 0.567 l -0.115 0 c -0.071 0 -0.129 0.064 -0.129 0.143 c 0 0.073 0.05 0.131 0.113 0.139 c -0.027 0.026 -0.045 0.064 -0.045 0.107 c 0 0.079 0.056 0.143 0.124 0.143 h 0.017 l -0.121 1.034 h -0.019 c -0.074 0 -0.133 0.07 -0.133 0.157 C 37.146 37.956 37.205 38.026 37.279 38.026 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.226 45.769 h -0.03 l -0.111 -1.034 h 0.019 c 0.068 0 0.124 -0.064 0.124 -0.143 c 0 -0.044 -0.018 -0.082 -0.046 -0.108 c 0.062 -0.011 0.11 -0.067 0.11 -0.139 c 0 -0.079 -0.058 -0.143 -0.129 -0.143 l -0.108 0 l -0.019 -0.567 h 0.014 c 0.064 0 0.117 -0.051 0.117 -0.112 l 0.001 -0.367 l -0.249 0.001 v 0.152 h -0.112 v -0.155 l -0.255 0.001 v 0.155 H 39.44 v -0.155 l -0.255 0 l 0.001 0.37 c 0 0.063 0.049 0.11 0.114 0.11 h 0.02 l -0.021 0.567 l -0.164 0 l -0.031 -1.117 h 0.029 c 0.065 0 0.119 -0.051 0.119 -0.112 l 0.001 -0.346 l 0 -0.027 l -0.023 0.007 l -0.231 0 v 0.151 h -0.115 v -0.155 l -0.259 0.001 v 0.154 h -0.115 v -0.155 h -0.26 l 0 0.37 c 0 0.063 0.05 0.111 0.116 0.111 h 0.038 l -0.03 1.117 l -0.163 0 l -0.019 -0.567 h 0.014 c 0.064 0 0.117 -0.051 0.117 -0.112 l 0 -0.367 l -0.249 0.001 v 0.152 h -0.112 v -0.155 l -0.255 0.001 v 0.155 h -0.112 v -0.155 l -0.255 0 l 0 0.37 c 0 0.063 0.049 0.11 0.114 0.11 h 0.02 l -0.021 0.567 l -0.115 0 c -0.071 0 -0.129 0.064 -0.129 0.143 c 0 0.073 0.05 0.131 0.113 0.139 c -0.027 0.026 -0.045 0.064 -0.045 0.107 c 0 0.079 0.056 0.143 0.124 0.143 h 0.017 l -0.121 1.034 h -0.019 c -0.074 0 -0.133 0.07 -0.133 0.157 c 0 0.086 0.06 0.156 0.133 0.156 h 2.947 c 0.074 0 0.133 -0.07 0.133 -0.156 C 40.36 45.839 40.3 45.769 40.226 45.769 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.451 52.763 l -0.079 -0.079 l 0.11 -0.11 l -0.18 -0.18 l -0.11 0.109 l -0.079 -0.08 l 0.11 -0.11 l -0.18 -0.18 l -0.262 0.261 c -0.045 0.044 -0.044 0.112 0.002 0.158 l 0.014 0.014 l -0.417 0.384 l -0.106 -0.107 l 0.758 -0.822 l 0.024 0.024 c 0.024 0.024 0.056 0.036 0.087 0.036 c 0.028 0 0.056 -0.01 0.076 -0.03 l 0.246 -0.243 l 0.02 -0.015 l -0.021 -0.014 L 38.3 51.615 l -0.107 0.107 l -0.081 -0.082 l 0.11 -0.109 l -0.183 -0.183 l -0.109 0.109 l -0.081 -0.082 l 0.11 -0.109 l -0.183 -0.184 l -0.262 0.261 c -0.045 0.045 -0.043 0.114 0.003 0.16 l 0.03 0.03 l -0.007 0.007 l -0.819 0.747 l -0.105 -0.106 l 0.389 -0.413 l 0.01 0.01 c 0.023 0.024 0.055 0.035 0.085 0.035 c 0.028 0 0.056 -0.01 0.077 -0.031 l 0.261 -0.258 l -0.176 -0.176 l -0.108 0.107 l -0.079 -0.079 l 0.11 -0.11 l -0.18 -0.18 l -0.11 0.109 l -0.079 -0.08 l 0.11 -0.11 l -0.18 -0.181 l -0.262 0.261 c -0.045 0.045 -0.044 0.113 0.002 0.158 l 0.014 0.014 l -0.417 0.384 l -0.081 -0.082 c -0.024 -0.025 -0.057 -0.037 -0.095 -0.035 c -0.036 0.002 -0.07 0.018 -0.097 0.044 c -0.051 0.051 -0.057 0.126 -0.02 0.177 c 0 0 0 0 0 0 c -0.038 0 -0.077 0.017 -0.106 0.046 c -0.027 0.026 -0.043 0.06 -0.046 0.095 c -0.003 0.036 0.008 0.069 0.032 0.093 l 0.012 0.012 l -0.819 0.643 l -0.013 -0.013 c -0.052 -0.052 -0.144 -0.045 -0.205 0.016 c -0.061 0.061 -0.069 0.152 -0.017 0.205 l 2.077 2.091 c 0.023 0.023 0.054 0.035 0.088 0.035 c 0.004 0 0.008 0 0.013 0 c 0.038 -0.003 0.075 -0.021 0.104 -0.05 c 0.033 -0.032 0.051 -0.075 0.052 -0.118 c 0 -0.034 -0.012 -0.065 -0.034 -0.087 l -0.021 -0.021 l 0.656 -0.808 l 0.013 0.014 c 0.048 0.049 0.133 0.043 0.189 -0.013 c 0.031 -0.031 0.045 -0.071 0.045 -0.108 c 0.021 0.015 0.045 0.024 0.071 0.024 c 0.037 0 0.075 -0.015 0.105 -0.045 c 0.029 -0.028 0.045 -0.067 0.045 -0.105 c 0 -0.033 -0.012 -0.064 -0.035 -0.087 h 0 l -0.076 -0.077 l 0.389 -0.413 l 0.01 0.01 c 0.022 0.022 0.053 0.035 0.085 0.035 c 0 0 0 0 0 0 c 0.03 0 0.057 -0.011 0.077 -0.031 l 0.26 -0.258 l -0.176 -0.177 L 38.451 52.763 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.564 46.141 L 29.564 46.141 c -0.001 0.367 0.136 0.721 0.385 0.99 c 0.237 0.255 0.564 0.414 0.922 0.414 c 0.359 0 0.686 -0.157 0.922 -0.411 c 0.236 -0.254 0.383 -0.604 0.383 -0.99 v -1.873 l -2.607 -0.002 L 29.564 46.141",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,51,153)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.564 41.617 L 29.564 41.617 c -0.001 0.367 0.136 0.721 0.385 0.99 c 0.237 0.255 0.564 0.414 0.922 0.414 c 0.359 0 0.686 -0.157 0.922 -0.411 c 0.236 -0.254 0.383 -0.604 0.383 -0.99 v -1.873 l -2.607 -0.002 L 29.564 41.617",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,51,153)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.947 46.141 L 25.947 46.141 c -0.001 0.367 0.136 0.721 0.385 0.99 c 0.237 0.255 0.564 0.414 0.922 0.414 c 0.359 0 0.686 -0.157 0.922 -0.411 c 0.236 -0.254 0.383 -0.604 0.383 -0.99 v -1.873 l -2.607 -0.002 L 25.947 46.141",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,51,153)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.172 46.141 L 33.172 46.141 c -0.001 0.367 0.136 0.721 0.385 0.99 c 0.237 0.255 0.564 0.414 0.922 0.414 c 0.359 0 0.686 -0.157 0.922 -0.411 c 0.236 -0.254 0.383 -0.604 0.383 -0.99 v -1.873 l -2.607 -0.002 L 33.172 46.141",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,51,153)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.564 50.626 L 29.564 50.626 c -0.001 0.367 0.136 0.721 0.385 0.99 c 0.237 0.255 0.564 0.414 0.922 0.414 c 0.359 0 0.686 -0.157 0.922 -0.411 c 0.236 -0.254 0.383 -0.604 0.383 -0.99 v -1.873 l -2.607 -0.002 L 29.564 50.626",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,51,153)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugalFlag);
export default __webpack_public_path__ + "static/media/portugal-flag.195fc0812426d3bdcb18b947fada34b9.svg";
export { ForwardRef as ReactComponent };